import React, { useEffect, useState } from 'react';
import './Menu.css';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveMenuItem } from '../../store/menuSlice.js'; // Importujemy akcję do aktualizacji aktywnego linku
import { clearTokens } from '../../store/tokensSlice.js';
import MenuButton from './menuButton.jsx';

import { ReactComponent as Ticket } from '../icons/ticket.svg';
import { ReactComponent as StatusUp } from '../icons/status-up.svg';
import { ReactComponent as Cup } from '../icons/cup.svg';
import { ReactComponent as Lock } from '../icons/lock.svg';
import { ReactComponent as Logout } from '../icons/logout.svg';
import { ReactComponent as Settings } from '../icons/settings.svg';
import { ReactComponent as UserSquare } from '../icons/user-square.svg';
import { ReactComponent as MapenLogo } from '../icons/logo.svg';
import { ReactComponent as Test } from '../icons/ticket.svg';

import { useLocation } from 'react-router-dom';
import ProfileModal from './profileModal.jsx';
import SettingsModal from './settingsModal.jsx';

function Menu() {
  const location = useLocation();
  const activeLink = useSelector((state) => state.menu.activeMenuItem); // Pobranie aktywnego linku z Redux  
  const dispatch = useDispatch();

    // Stan dla modali
    const [isProfileModalOpen, setProfileModalOpen] = useState(false);
    const [isSettingsModalOpen, setSettingsModalOpen] = useState(false);

  const handleLinkClick = (path) => {
    dispatch(setActiveMenuItem(path)); // Aktualizacja aktywnego linku w Redux
  };

   // Wywołanie handleLinkClick przy pierwszym ładowaniu
   useEffect(() => {
    handleLinkClick(location.pathname); // Wywołanie funkcji z aktualną ścieżką
  }, [location.pathname]); // Uruchomienie efektu, gdy zmieni się ścieżka

  const handleLogoutClick = (path) => {
    dispatch(clearTokens()); // Ustawienie tokenu dostępu na pusty
    window.location.reload(); // Odświeżenie strony po wylogowaniu
  };

  const menuItems = [
    { path: '/', icon: Ticket, label: 'Wydarzenia' },
    // { path: '/promo', icon: Cup, label: 'Promowanie wydarzeń', disabled: true, lockIcon: Lock },
    { path: '/statistics', icon: StatusUp, label: 'Statystyki' },
    // { path: '/paymenttest', icon: Test, label: 'Test'}

  ];


    // Funkcja pomocnicza do otwierania ustawień z poziomu profilu (link "Zmień hasło")
    const openSettingsFromProfile = () => {
        setProfileModalOpen(false);
        setSettingsModalOpen(true);
    };

  return (
    <div className="menu">
      <div className="menu-content">
        {/* Logo po lewej stronie */}
        <div className="menu-logo">
          <MapenLogo className="menu-icon-without-text" />
        </div>

        {/* Środkowy div z wyśrodkowanymi dziećmi */}
        <div className="menu-center">
          {menuItems.map((item) => (
            <MenuButton
              key={item.path}
              path={item.path}
              currentPath={activeLink}
              onClick={handleLinkClick}
              icon={item.icon}
              label={item.label}
              disabled={item.disabled}
              lockIcon={item.lockIcon}
              showLabel={true}
              showSpeechBubble={true}
            />
          ))}
        </div>

        {/* Prawy div */}
        <div className="menu-right">
          <MenuButton
            path="#"
            currentPath={activeLink}
            onClick={() => setSettingsModalOpen(true)} // Otwieranie modalu ustawień
            icon={Settings}
            label=""
            afterClickingChange={false}
          />
          <MenuButton
            path="#"
            currentPath={activeLink}
            onClick={() => setProfileModalOpen(true)} // Otwieranie modalu profilu
            icon={UserSquare}
            label=""
            afterClickingChange={false}
          />
          <MenuButton
            path="/logout"
            currentPath={activeLink}
            onClick={handleLogoutClick}
            icon={Logout}
            label="Wyloguj się"
            iconfirst={false}
            afterClickingChange={false}
            borders="L" // Przykład użycia ramek (L - lewa, R - prawa, B - dolna, T - górna)
          />
        </div>
      </div>

        {/* Renderowanie Modali */}
        {isProfileModalOpen && (
            <ProfileModal
                onClose={() => setProfileModalOpen(false)}
                onChangePassword={openSettingsFromProfile}
            />
        )}

        {isSettingsModalOpen && (
            <SettingsModal
                onClose={() => setSettingsModalOpen(false)}
            />
        )}
    </div>
  );
}

export default Menu;
